module.exports = __webpack_public_path__ + "img/login_banner_xl_driver.3675b619.png";